// Процент отступа от максимального значениям(отступ сверху 10% от максимального Y)
const PERCENTAGE = 10;

const getDomain = ({
  maxVolume, minVolume, barMax, barMin
}) => {
  if (!maxVolume && !minVolume && !barMax && !barMin) {
    return null;
  }

  let max = barMax;
  let min = 0;

  if (barMax < maxVolume) {
    max = maxVolume;
  }
  if (barMin > minVolume) {
    min = minVolume;
  }

  return [min, max + (max * PERCENTAGE) / 100];
};

export default getDomain;
